<div class="custom-table">
  <div class="table__responsive modal">
    <div class="table-wrapper">
      <div class="table-wrapper-inner limited" [class.custom-1]="customH == 'custom-1'">
        <table mat-table [dataSource]="dataSource" matSort class="not-wrap">

          <!-- Columns -->
          <ng-container [matColumnDef]="column.variable" *ngFor="let column of displayedColumns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.displayedName }}</th>
            <td mat-cell *matCellDef="let row let i = index">
              <!-- <div *ngIf="column.variable != 'options' && column.variable != 'Estado' && column.variable != 'area' && column.variable != 'fldCriticality'"> -->
              <div *ngIf="!(['options-prod-serv', 'badge',  'product_price_limited', 'product_price_mod_percentage', 'charge_type_translated'].indexOf(column.variable) > -1)">
                {{ row[column.variable] || '---' }}
              </div>

              <div *ngIf="column.variable == 'options-prod-serv'">
                <button class="icon-btn danger" (click)="editProductService(row)">
                  <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
                </button>
                <button class="icon-btn danger" (click)="removeProductService(row)">
                  <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
                </button>
              </div>

              <div *ngIf="column.variable == 'charge_type_translated'">
                <span *ngIf="row['type'] == 'percentage'">
                  Porcentage
                </span>
                <span *ngIf="row['type'] == 'flat_fee'">
                  Tarifa plana
                </span>
              </div>

              <div *ngIf="column.variable == 'badge'">
                Bs
              </div>

              <div *ngIf="column.variable == 'product_price_limited'">
                {{ row['product_price'] | number: '1.2-2' }}
              </div>

              <div *ngIf="column.variable == 'product_price_mod_percentage'">
                <div *ngIf="row['price_type'] == 'percentage'; else elseIf">
                  {{ row['product_price'] | number: '1.2-2' }}
                </div>
                <ng-template #elseIf>
                  {{ row['product_price'] | number: '1.2-2' }}
                </ng-template>
              </div>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns_aux"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns_aux;" [class.hidden]="row.status == 'inactive'"></tr>

        </table>
      </div>
    </div>
  </div>
</div>
